import { render, staticRenderFns } from "./DissociateButton.vue?vue&type=template&id=4d744855&"
import script from "./DissociateButton.vue?vue&type=script&lang=js&"
export * from "./DissociateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports